import { Box, Heading3, Table } from "@nulogy/components";
import React from "react";
import styled from "styled-components";

function ExecutionSummary({ testId, content }) {
  return <Box data-testid={testId}>{content}</Box>;
}

const TopAlignedTable = styled(Table)(({ theme }) => ({
  marginTop: theme.sizes.x2,

  "tr td": {
    paddingTop: theme.sizes.x2,
    verticalAlign: "top",
  },
}));

function PublishResultSection({ rows, title, testIdPrefix, summary, columns }) {
  if (rows.length === 0) return null;

  return (
    <>
      <Heading3 mt="x3">{title}</Heading3>
      <ExecutionSummary content={summary} testId={`${testIdPrefix}-summary`} />
      <TopAlignedTable columns={columns} data-testid={`${testIdPrefix}-table`} rows={rows} />
    </>
  );
}

export { ExecutionSummary, PublishResultSection };
